import React from 'react'
import { IconRotateClockwise2 } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

import { formatVersionDate } from '../drawerHelpers'

// Shared "Viewing <date> version" footer with a Revert affordance, used by the
// prompt tab and the tools/variables OverrideEditor. `testIdPrefix` scopes the
// test ids (OverrideEditor namespaces per field; the prompt tab uses the bare
// `viewing-strip`). `busy` disables revert during an in-flight request;
// staleness (the variable contract changed since this version) always disables it.
const VersionViewingStrip = ({ version, onRevert, testIdPrefix, busy = false }) => {
  const isStale = version.isCurrentSignature === false
  const base = testIdPrefix ? `${testIdPrefix}-viewing-strip` : 'viewing-strip'
  return (
    <div className="voice-agents__viewing-strip" data-testid={base}>
      <span className="voice-agents__viewing-strip-label">
        Viewing {formatVersionDate(version.createdAt)} version
      </span>
      <Button
        basic
        small
        onClick={onRevert}
        disabled={isStale || busy}
        className="voice-agents__viewing-strip-revert"
        title={isStale ? 'Variable contract changed since this version' : 'Revert to this version'}
        data-testid={`${base}-revert`}
      >
        <IconRotateClockwise2 /> Revert to this version
      </Button>
    </div>
  )
}

export default VersionViewingStrip
